import {
	Component,
	Injector,
} from '@angular/core';

import { NgForm } from '@angular/forms';

import { finalize } from 'rxjs/operators';
import { UIRouter } from '@uirouter/angular';

import { CommonBaseComponent } from '../../../Common/components/base.component';
import { CommonAppDataService } from '../../../Common/services/app_data/app_data.service';
import { CommonUserDataService } from '../../../Common/services/user_data.service';

import {
	AuthenticationMeetingsUserService,
	IAuthenticationMeetingsUserActionsResponse,
} from '../authentication/services/authentication.meetings.user.service';
import { AuthenticationMeetingsErrorService } from '../authentication/services/authentication.meetings.error.service';
import { MeetingsAuthAnimation } from '../animation/animation';
import { IAuthenticationMeetingsLoginUser } from '../authentication/authentication.interfaces';

@Component({
	selector: 'authentication-meetings-login',
	templateUrl: './authentication.meetings.login.component.pug',
	animations: [
		MeetingsAuthAnimation,
	],
})
export class AuthenticationMeetingsLoginComponent extends CommonBaseComponent {
	state = {
		isLoading: false,
	};

	user: IAuthenticationMeetingsLoginUser = {
		PhoneNumber: '',
		Password: '',
	};

	resource = {
		validationCustomErrors: {
			custom: '',
			minLength: this.instant('meetings_auth.forms.login.controls.password.messages.minlength'),
		},
	};

	onChangeFieldHandler = this.authenticationMeetingsErrorService.onChangeFieldHandler;

	constructor (
		protected injector: Injector,
		private authenticationMeetingsUserService: AuthenticationMeetingsUserService,
		private router: UIRouter,
		private authenticationMeetingsErrorService: AuthenticationMeetingsErrorService,
		private commonAppData: CommonAppDataService,
		private commonUserDataService: CommonUserDataService,
	) {
		super(injector);
	}

	ngOnInit (): void {
		if (this.commonAppData.getDataByPath('isAccountNotExists')) {
			this.commonAppData.setDataByPath(false, 'isAccountNotExists');
			this.router.stateService.go('registration');
		}
	}

	login (form: NgForm) {
		if (form.valid) {
			this.state.isLoading = true;

			this.authenticationMeetingsUserService
				.login(this.user)
				.pipe(
					finalize(() => this.state.isLoading = false),
				)
				.subscribe((response: IAuthenticationMeetingsUserActionsResponse) => {
					if (response.IsSuccess) {
						this.commonUserDataService.setDataByPath(response.Result.ExpiresAt, 'nextPhoneConfirmationAttemptTime');
						this.commonUserDataService.setDataByPath(this.user.PhoneNumber, 'phoneNumber');

						this.router.stateService.go('confirm');
					} else {
						this.authenticationMeetingsErrorService.handleSuccessResponse(response, this.resource.validationCustomErrors, form.controls.password);
					}
				});
		}
	}

	getAboutUrl (): string {
		return this.commonAppData.getDataByPath('aboutPage') || '';
	}
}
